import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Price } from '@thd-olt-component-react/price';
import { TAX_MESSAGING } from '../../constants';
import { usePartsAndServices } from '../PartsAndServicesProvider';
import { getPricingObjectForTotal } from '../../utils';

export const Total = () => {
  const {
    haulAwaySelections,
    installationSelections,
    protectionSelections,
    productsMap,
    showLoadingSkeleton,
    isPSPPServiceDown,
    newProductSelections
  } = usePartsAndServices();
  const { isExchangeCustomer } = useThdCustomer() || {};
  const { channel } = useContext(ExperienceContext);

  const totalPriceObj = getPricingObjectForTotal({
    productsMap,
    isExchangeCustomer,
    protectionSelections,
    installationSelections,
    haulAwaySelections,
    newProductSelections
  });

  const newPriceObject = !showLoadingSkeleton ? totalPriceObj : {};
  const { hideTotal = false } = totalPriceObj || {};

  return (
    <section data-testid="total-section">
      {!isPSPPServiceDown && (
        <div className="sui-flex sui-justify-center sui-gap-1">
          <Typography variant="body-lg">Total</Typography>
          {!showLoadingSkeleton && (
            <span style={{ minHeight: '28px' }}>
              {hideTotal && (
                <Typography variant="body-lg" weight="bold" align="center">
                  See Price in Cart
                </Typography>
              )}
              {!hideTotal && (
                <Price
                  hideSavingsText
                  large={false}
                  channel={channel}
                  itemId=""
                  product={newPriceObject}
                  type="simple"
                />
              )}
            </span>
          )}
        </div>
      )}
      {(!isExchangeCustomer && !isPSPPServiceDown) && (
        <div className="sui-flex sui-justify-center">
          <Typography variant="body-xs">
            {TAX_MESSAGING}
          </Typography>
        </div>
      )}
    </section>
  );
};

Total.displayName = 'Total';
